import { render, staticRenderFns } from "./client-table.vue?vue&type=template&id=74be3d7f"
import script from "./client-table.vue?vue&type=script&lang=js"
export * from "./client-table.vue?vue&type=script&lang=js"
import style0 from "./client-table.vue?vue&type=style&index=0&id=74be3d7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports